import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LiveHeaderComponent from './js/live-header.component';

ComponentsFactory.getInstance().define('live-header', LiveHeaderComponent);
